import beige from './beige.module.scss';
import darkGreen from './darkGreen.module.scss';
import green from './green.module.scss';
import liveGreen from './liveGreen.module.scss';
import purple from './purple.module.scss';
import white from './white.module.scss';
import yellow from './yellow.module.scss';

export { beige, darkGreen, green, liveGreen, purple, white, yellow };
